import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { ShowcaseWorkflowStateView } from "./ShowcaseWorkflowStateView";
import { ShowcaseWorkflowStateViewStore } from "../../store/ShowcaseWorkflowStateViewStore";
import { useStore } from "../../../../hooks";

export const ShowcaseWorkflowStateViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/showcaseWorkflowState/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new ShowcaseWorkflowStateViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <ShowcaseWorkflowStateView showcaseWorkflowStateViewStore={store} />
      </PageLayout>
    </div>
  );
});
